import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowTopLeftCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-top-left-corner"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowTopLeftCorner"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM6 13H7V7.70703L13 13.707L13.707 13L7.70703 7H13V6H6V13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowTopLeftCorner;
